import { useContext } from 'react';

import type { TruncationMode } from '../../../typography/text-ellipsis/TextEllipsis.js';
import { FormatterContext } from '../context/FormatterContext.js';

export const useTruncationMode = (): TruncationMode => {
  return useContext(FormatterContext)?.truncationMode;
};
